import { loadUser } from "../redux/action/authAction";
import store from "../redux/store";

export const fetchUserData = () => {
    const {
        auth: { user },
    } = store.getState();
    if (user?.site_id && user?.user_id) {
        store.dispatch(
            loadUser({
                site_id: user.site_id,
            })
        );
    }
};
